import dayjs from 'dayjs';
import { I18n } from 'react-redux-i18n-lite';
import { REDUCER } from '../reducers/reducersConst';
import { DISCUSSION_MESSAGES_ORDER_OBJECT, DISCUSSION_TABS_CONSTANTS } from '../const';
import * as discussionApi from '../services/api/discussionApi';
import * as messageAlert from './messageAlertAction';
import { getLogger } from '../services/logger';
import * as drawerActions from './drawerActions';
import { deleteDiscussion } from '../services/api/discussionApi';
import {
  addLikeToMessage,
  addNewAccessToDiscussion,
  addNewMessageToDiscussion,
  addReplyToMessage,
  removeMessageFromDiscussion,
  updateMessage
} from '../services/xapi/xApiEventsService';
import { isFuture, isPast } from '../utils/dateUtlis';
import * as analyticsApi from '../services/api/analyticsApi';
import { ANALYTICS_CONTEXT, ANALYTICS_EVENT } from '../types/analytics';

const debug = getLogger('actions:discussionActions');

/**
 * Saves in store the current discussion associated with the selected classroom
 * @param discussions
 * @returns {{type: string, discussions: array}}
 */
export let setCurrentDiscussions = (discussions = []) => {
  return {
    type: REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS,
    discussions
  };
};

/**
 * Saves in store the current discussion page
 * @param currentPage
 * @returns {{type: string, currentPage: number}}
 */
export let setCurrentDiscussionsCurrentPage = (currentPage = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS_CURRENT_PAGE,
    currentPage
  };
};

/**
 * Saves in store the number of pages
 * @param pages
 * @returns {{type: string, pages: number}}
 */
export let setCurrentDiscussionsPages = (pages = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS_PAGES,
    pages
  };
};

/**
 * Saves in store the fetching state
 * @param fetching
 * @returns {{type: string, fetching: boolean}}
 */
export let setCurrentDiscussionsFetching = (fetching = false) => {
  return {
    type: REDUCER.DISCUSSION.SET_CURRENT_DISCUSSIONS_FETCHING,
    fetching
  };
};

/**
 * Saves in store the finished discussion associated with the selected classroom
 * @param discussions
 * @returns {{type: string, discussion: array}}
 */
export let setFinishedDiscussions = (discussions = []) => {
  return {
    type: REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS,
    discussions
  };
};

/**
 * Saves in store the finished discussion page
 * @param currentPage
 * @returns {{type: string, currentPage: number}}
 */
export let setFinishedDiscussionsCurrentPage = (currentPage = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS_CURRENT_PAGE,
    currentPage
  };
};

/**
 * Saves in store the number of pages
 * @param pages
 * @returns {{type: string, pages: number}}
 */
export let setFinishedDiscussionsPages = (pages = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS_PAGES,
    pages
  };
};

/**
 * Saves in store the fetching state
 * @param fetching
 * @returns {{type: string, fetching: boolean}}
 */
export let setFinishedDiscussionsFetching = (fetching = false) => {
  return {
    type: REDUCER.DISCUSSION.SET_FINISHED_DISCUSSIONS_FETCHING,
    fetching
  };
};

/**
 * Saves in store the finished discussion associated with the selected classroom
 * @param discussions
 * @returns {{type: string, discussion: array}}
 */
export let setFutureDiscussions = (discussions = []) => {
  return {
    type: REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS,
    discussions
  };
};

/**
 * Saves in store the finished discussion page
 * @param currentPage
 * @returns {{type: string, currentPage: number}}
 */
export let setFutureDiscussionsCurrentPage = (currentPage = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS_CURRENT_PAGE,
    currentPage
  };
};

/**
 * Saves in store the number of pages
 * @param pages
 * @returns {{type: string, pages: number}}
 */
export let setFutureDiscussionsPages = (pages = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS_PAGES,
    pages
  };
};

/**
 * Saves in store the fetching state
 * @param fetching
 * @returns {{type: string, fetching: boolean}}
 */
export let setFutureDiscussionsFetching = (fetching = false) => {
  return {
    type: REDUCER.DISCUSSION.SET_FUTURE_DISCUSSIONS_FETCHING,
    fetching
  };
};

export let setDiscussionStudentsAssigned = studentsAssigned => {
  return {
    type: REDUCER.DISCUSSION.SET_STUDENTS_ASSIGNED,
    studentsAssigned
  };
};

export let setSelectedDiscussion = (discussion = {}) => {
  return {
    type: REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION,
    discussion
  };
};

/**
 * Saves in store the fetching state
 * @param fetching
 * @returns {{type: string, fetching: boolean}}
 */
export let setSelectedDiscussionsFetching = (fetching = false) => {
  return {
    type: REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_FETCHING,
    fetching
  };
};

export let setSelectedDiscussionMessages = (messages = []) => {
  return {
    type: REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES,
    messages
  };
};

export let setSelectedDiscussionMessagesOrder = (messagesOrder = DISCUSSION_MESSAGES_ORDER_OBJECT.OLDER_FIRST) => {
  return {
    type: REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_ORDER,
    messagesOrder
  };
};

export let setSelectedDiscussionMessagesFetching = (fetching = false) => {
  return {
    type: REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_FETCHING,
    fetching
  };
};

export let setSelectedDiscussionMessagesPages = (pages = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_PAGES,
    pages
  };
};

export let setSelectedDiscussionMessagesCurrentPage = (currentPage = 0) => {
  return {
    type: REDUCER.DISCUSSION.SET_SELECTED_DISCUSSION_MESSAGES_CURRENT_PAGE,
    currentPage
  };
};

export let setActiveTab = activeDiscussionTab => {
  return {
    type: REDUCER.DISCUSSION.SET_ACTIVE_TAB,
    activeDiscussionTab
  };
};

export let setRemoveDiscussionRevealOpen = (removeDiscussionRevealIsOpen = true) => {
  return {
    type: REDUCER.DISCUSSION.SET_REMOVE_MODAL_OPEN,
    removeDiscussionRevealIsOpen
  };
};

export let setRemoveDiscussionRevealData = (discussion = {}) => {
  return {
    type: REDUCER.DISCUSSION.SET_REMOVE_MODAL_DATA,
    discussion
  };
};

export let setCloseDiscussionRevealOpen = (closeDiscussionRevealIsOpen = true) => {
  return {
    type: REDUCER.DISCUSSION.SET_CLOSE_MODAL_OPEN,
    closeDiscussionRevealIsOpen
  };
};

export let setCloseDiscussionRevealData = (discussion = {}) => {
  return {
    type: REDUCER.DISCUSSION.SET_CLOSE_MODAL_DATA,
    discussion
  };
};

export let getCurrentDiscussions = (classroomId, page) => {
  return async dispatch => {
    if (classroomId) {
      dispatch(setCurrentDiscussionsFetching(true));

      try {
        // A single status-filtered call covers both content and classroom discussions -
        // combining it with a second, unfiltered call (paginated independently over every
        // status) made content discussions leak in from other tabs and duplicate across
        // pages whenever the two calls' page boundaries didn't line up.
        const resInProgress = await dispatch(
          getDiscussions(classroomId, DISCUSSION_TABS_CONSTANTS.IN_PROGRESS.key, page)
        );
        const allDiscussions = resInProgress._embedded ? resInProgress._embedded.discussions : [];

        dispatch(setCurrentDiscussionsPages(resInProgress.page.totalPages));
        dispatch(setCurrentDiscussionsFetching());
        dispatch(setCurrentDiscussions(addMomentToDiscussions(allDiscussions)));
      } catch (error) {
        dispatch(setCurrentDiscussionsFetching());
        debug.error('[getCurrentDiscussions] error getting current Discussions', error);
        dispatch(messageAlert.error(I18n.t('discussions.messageAlert.discussionsError')));
      }
    }
  };
};

export let getFinishedDiscussions = (classroomId, page) => {
  return dispatch => {
    if (classroomId) {
      dispatch(setFinishedDiscussionsFetching(true));
      return dispatch(getDiscussions(classroomId, DISCUSSION_TABS_CONSTANTS.FINISHED.key, page))
        .then(res => {
          dispatch(setFinishedDiscussionsPages(res.page.totalPages));
          dispatch(setFinishedDiscussionsFetching());
          dispatch(setFinishedDiscussions(addMomentToDiscussions(res._embedded ? res._embedded.discussions : [])));
        })
        .catch(error => {
          dispatch(setFinishedDiscussionsFetching());
          debug.error('[getFinishedDiscussions] error getting finished Discussions', error);
          dispatch(messageAlert.error(I18n.t('discussions.messageAlert.discussionsError')));
        });
    }
  };
};

export let getFutureDiscussions = (classroomId, page) => {
  return dispatch => {
    if (classroomId) {
      dispatch(setFutureDiscussionsFetching(true));
      return dispatch(getDiscussions(classroomId, DISCUSSION_TABS_CONSTANTS.FUTURE.key, page))
        .then(res => {
          dispatch(setFutureDiscussionsPages(res.page.totalPages));
          dispatch(setFutureDiscussionsFetching());
          dispatch(setFutureDiscussions(addMomentToDiscussions(res._embedded ? res._embedded.discussions : [])));
        })
        .catch(error => {
          dispatch(setFutureDiscussionsFetching());
          debug.error('[getFutureDiscussions] error getting future Discussions', error);
          dispatch(messageAlert.error(I18n.t('discussions.messageAlert.discussionsError')));
        });
    }
  };
};

const getDiscussions = (classroomId, status, page) => {
  return (dispatch, getState) => {
    if (classroomId) {
      page = page ? page : getCurrentPage(getState().discussions, status);
      return discussionApi.getPaginatedDiscussions(classroomId, status, page);
    }
  };
};

export let getDiscussion = discussionId => {
  return dispatch => {
    dispatch(setSelectedDiscussionsFetching(true));
    return discussionApi
      .getDiscussion(discussionId)
      .then(res => {
        dispatch(setSelectedDiscussion(res.data));
        dispatch(setSelectedDiscussionsFetching());
      })
      .catch(error => {
        dispatch(setSelectedDiscussionsFetching());
        dispatch(messageAlert.error(I18n.t('discussions.messageAlert.discussionError')));
        debug.error('[getDiscussion] error getting Discussion', error);
      });
  };
};

export let removeDiscussion = discussion => {
  return (dispatch, getState) => {
    const startedAt = Date.now();
    deleteDiscussion(discussion.id)
      .then(res => {
        if (isPast(discussion.dueDate)) {
          const currentPage = getState().discussions.finishedDiscussions.currentPage;
          const totalPages = getState().discussions.finishedDiscussions.pages;
          const discussions = getState().discussions.finishedDiscussions.discussions;
          if (discussions.length === 1 && currentPage !== 0 && currentPage === totalPages - 1) {
            dispatch(setFinishedDiscussionsCurrentPage(currentPage - 1));
          }
        } else if (isFuture(discussion.startDate)) {
          const currentPage = getState().discussions.futureDiscussions.currentPage;
          const totalPages = getState().discussions.futureDiscussions.pages;
          const discussions = getState().discussions.futureDiscussions.discussions;
          if (discussions.length === 1 && currentPage !== 0 && currentPage === totalPages - 1) {
            dispatch(setFutureDiscussionsCurrentPage(currentPage - 1));
          }
        } else {
          const currentPage = getState().discussions.currentDiscussions.currentPage;
          const totalPages = getState().discussions.currentDiscussions.pages;
          const discussions = getState().discussions.currentDiscussions.discussions;
          if (discussions.length === 1 && currentPage !== 0 && currentPage === totalPages - 1) {
            dispatch(setCurrentDiscussionsCurrentPage(currentPage - 1));
          }
        }
        dispatch(updateDiscussionsLists());
        dispatch(drawerActions.setDrawerClosed());
        dispatch(messageAlert.info(`${I18n.t('discussions.messageAlert.discussionRemoved')}`));
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.DELETE_DISCUSSION,
          classId: getState().classrooms.selectedClassroom.classroom.id,
          discussionId: discussion.id,
          context: ANALYTICS_CONTEXT.DISCUSSION_REMOVE_REVEAL,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
        return res.data;
      })
      .catch(error => {
        debug.error('[removeDiscussion] %s', error);
        dispatch(
          messageAlert.error(
            `${I18n.t('discussions.messageAlert.removeDiscussionError', { discussionName: discussion.title })}`
          )
        );
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.DELETE_DISCUSSION,
          classId: getState().classrooms.selectedClassroom.classroom.id,
          discussionId: discussion.id,
          context: ANALYTICS_CONTEXT.DISCUSSION_REMOVE_REVEAL,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

export let closeDiscussion = discussionId => {
  return (dispatch, getState) => {
    analyticsApi.trackAnalyticsEvent({
      event: ANALYTICS_EVENT.CLOSE_DISCUSSION,
      classId: getState().classrooms.selectedClassroom.classroom.id,
      discussionId,
      context: ANALYTICS_CONTEXT.DISCUSSION_CLOSE_REVEAL,
      status: 'success'
    });
    dispatch(updateDiscussion({ dueDate: dayjs() }, discussionId));
  };
};

export const updateDiscussion = (discussion, discussionId) => {
  return dispatch => {
    return discussionApi
      .updateDiscussion(discussion, discussionId)
      .then(res => {
        dispatch(updateDiscussionsLists());
        dispatch(drawerActions.setDrawerClosed());
        dispatch(messageAlert.info(`${I18n.t('discussions.messageAlert.discussionUpdated')}`));
        return res.data;
      })
      .catch(error => {
        debug.error('[editDiscussion] %s', error);
        dispatch(
          messageAlert.error(
            `${I18n.t('discussions.messageAlert.discussionUpdateError', { discussionName: discussion.title })}`
          )
        );
      });
  };
};

export const updateDiscussionsLists = () => {
  return (dispatch, getState) => {
    const classroom = getState().classrooms.selectedClassroom.classroom;
    const finishedDiscussionsPage = getState().discussions.finishedDiscussions.currentPage;
    const futureDiscussionsPage = getState().discussions.futureDiscussions.currentPage;
    const currentDiscussionsPage = getState().discussions.currentDiscussions.currentPage;
    dispatch(getFinishedDiscussions(classroom.id, finishedDiscussionsPage));
    dispatch(getFutureDiscussions(classroom.id, futureDiscussionsPage));
    dispatch(getCurrentDiscussions(classroom.id, currentDiscussionsPage));
  };
};

// ------------------------ Messages Actions ------------------------

export const updateMessagesOrder = order => {
  return (dispatch, getState) => {
    const discussionId = getState().discussions.selectedDiscussion.discussion.id;
    dispatch(setSelectedDiscussionMessagesOrder(order));
    dispatch(setSelectedDiscussionMessagesCurrentPage());
    dispatch(getDiscussionMessages(discussionId, true));
  };
};

export let pushSelectedDiscussionMessages = (messages = []) => {
  return (dispatch, getState) => {
    const pushedMessages = getState().discussions.selectedDiscussion.messages.list.concat(messages);
    dispatch(setSelectedDiscussionMessages(pushedMessages));
  };
};

export let getDiscussionMessages = (discussionId, cleanDiscussionsAfterFetch = false) => {
  return (dispatch, getState) => {
    const discussion = getState().discussions.selectedDiscussion;
    if (discussion) {
      const messagesOrder = discussion.messages.messagesOrder.id;
      const currentPage = discussion.messages.currentPage;
      dispatch(setSelectedDiscussionMessagesFetching(true));
      return discussionApi
        .getDiscussionMessages(discussionId, messagesOrder, currentPage)
        .then(res => {
          if (cleanDiscussionsAfterFetch) {
            dispatch(setSelectedDiscussionMessages());
          }
          dispatch(pushSelectedDiscussionMessages(res._embedded ? res._embedded.messages : []));
          dispatch(setSelectedDiscussionMessagesPages(res.page.totalPages));
          dispatch(setSelectedDiscussionMessagesCurrentPage(res.page.number));
          dispatch(setSelectedDiscussionMessagesFetching());
        })
        .catch(error => {
          debug.error('[getDiscussionMessages] error getting selected discussion messages', error);
          dispatch(setSelectedDiscussionMessagesPages());
          dispatch(setSelectedDiscussionMessagesCurrentPage());
          dispatch(setSelectedDiscussionMessagesFetching());
          dispatch(messageAlert.error(I18n.t('discussions.messageAlert.discussionMessagesError')));
        });
    }
  };
};

export const addNewVisitToDiscussion = () => {
  return (dispatch, getState) => {
    const classroom = getState().classrooms.selectedClassroom.classroom;
    const user = getState().account.user;
    const routeParams = getState().router.params;
    const startedAt = Date.now();
    addNewAccessToDiscussion(routeParams.idDiscussion, user._id, classroom.id, classroom.institutionId, user.role)
      .then(() => {
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.VIEW_DISCUSSION,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          context: ANALYTICS_CONTEXT.DISCUSSION_DETAIL,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
      })
      .catch(error => {
        debug.error('[addNewVisitToDiscussion] error adding new visit to discussion', error);
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.VIEW_DISCUSSION,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          context: ANALYTICS_CONTEXT.DISCUSSION_DETAIL,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

export const sendMessageToDiscussion = messageText => {
  return (dispatch, getState) => {
    const classroom = getState().classrooms.selectedClassroom.classroom;
    const user = getState().account.user;
    const routeParams = getState().router.params;
    const startedAt = Date.now();
    addNewMessageToDiscussion(routeParams.idDiscussion, user, classroom.id, classroom.institutionId, messageText)
      .then(() => {
        messageAlert.success(I18n.t('discussions.messageAlert.messageCreated'));
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.POST_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
      })
      .catch(error => {
        messageAlert.error(I18n.t('discussions.messageAlert.messageCreateError'));
        debug.error('[sendMessageToDiscussion] error sending message', error);
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.POST_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

export const updateDiscussionMessage = (messageText, messageId) => {
  return (dispatch, getState) => {
    const classroom = getState().classrooms.selectedClassroom.classroom;
    const user = getState().account.user;
    const routeParams = getState().router.params;
    const startedAt = Date.now();
    updateMessage(routeParams.idDiscussion, user, classroom.id, classroom.institutionId, messageText, messageId)
      .then(() => {
        messageAlert.success(I18n.t('discussions.messageAlert.messageUpdated'));
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.EDIT_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
      })
      .catch(error => {
        messageAlert.error(I18n.t('discussions.messageAlert.messageUpdateError'));
        debug.error('[updateDiscussionMessage] error sending message', error);
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.EDIT_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

export const sendReplyToMessage = (messageText, replyTo) => {
  return (dispatch, getState) => {
    const classroom = getState().classrooms.selectedClassroom.classroom;
    const user = getState().account.user;
    const routeParams = getState().router.params;
    const startedAt = Date.now();
    addReplyToMessage(routeParams.idDiscussion, user, classroom.id, classroom.institutionId, messageText, replyTo)
      .then(() => {
        messageAlert.success(I18n.t('discussions.messageAlert.replyCreated'));
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.REPLY_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId: replyTo,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
      })
      .catch(error => {
        messageAlert.error(I18n.t('discussions.messageAlert.messageCreateError'));
        debug.error('[updateMessage] error sending message', error);
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.REPLY_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId: replyTo,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

export const removeMessage = messageId => {
  return (dispatch, getState) => {
    const classroom = getState().classrooms.selectedClassroom.classroom;
    const user = getState().account.user;
    const routeParams = getState().router.params;
    const startedAt = Date.now();
    removeMessageFromDiscussion(routeParams.idDiscussion, user, classroom.id, classroom.institutionId, messageId)
      .then(() => {
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.DELETE_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
      })
      .catch(error => {
        messageAlert.error(I18n.t('discussions.messageAlert.messageRemoveError'));
        debug.error('[removeMessage] error removing message', error);
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.DELETE_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

export const sendLikeToMessage = messageId => {
  return (dispatch, getState) => {
    const classroom = getState().classrooms.selectedClassroom.classroom;
    const user = getState().account.user;
    const routeParams = getState().router.params;
    const startedAt = Date.now();
    addLikeToMessage(routeParams.idDiscussion, user, classroom.id, classroom.institutionId, messageId)
      .then(() => {
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.LIKE_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
      })
      .catch(error => {
        messageAlert.error(I18n.t('discussions.messageAlert.messageLikeError'));
        debug.error('[sendLikeToMessage] setting like to message', error);
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.LIKE_DISCUSSION_MESSAGE,
          classId: classroom.id,
          discussionId: routeParams.idDiscussion,
          messageId,
          context: ANALYTICS_CONTEXT.DISCUSSION_MESSAGE_LIST,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

// Aux functions

const addMomentToDiscussions = discussions => discussions.map(discussion => addMomentToSingleDiscussion(discussion));

const addMomentToSingleDiscussion = discussion => {
  discussion.startDate = dayjs(discussion.startDate);
  discussion.dueDate = dayjs(discussion.dueDate);
  return discussion;
};

const getCurrentPage = (discussions, status) => {
  if (status === DISCUSSION_TABS_CONSTANTS.FINISHED.key) {
    return discussions.finishedDiscussions.currentPage;
  } else if (status === DISCUSSION_TABS_CONSTANTS.IN_PROGRESS.key) {
    return discussions.currentDiscussions.currentPage;
  } else if (status === DISCUSSION_TABS_CONSTANTS.FUTURE.key) {
    return discussions.futureDiscussions.currentPage;
  }
};
